import React from 'react';
import { FaLinkedin } from 'react-icons/fa';
import { FaGithubSquare } from 'react-icons/fa';

const Footer = () => {
	return (
		<div
			id='contact'
			className='flex flex-col justify-center items-center space-y-4 p-16 bg-[#333]'
		>
			<h4 className='text-xl text-white text-opacity-50 w-48 text-center sm:text-2xl'>
				Find me Online
			</h4>
			<div className='flex space-x-6 text-[#21a0c0]'>
				<a
					href='https://www.linkedin.com/in/firat-tezcan-ab77a7129/'
					target='_blank'
					rel='noopener noreferrer'
				>
					<FaLinkedin className='w-12 h-12 hover:text-[#166a7f]' />
				</a>
				<a
					href='https://github.com/Firat92'
					target='_blank'
					rel='noopener noreferrer'
				>
					<FaGithubSquare className='w-12 h-12 hover:text-[#166a7f]' />
				</a>
			</div>
			<div className='flex flex-col justify-center items-center space-x-2 text-white text-opacity-50 sm:text-lg'>
				<p>Contact Me: </p>
				<a href='mailto:firattezcan92@gmail.com'>firattezcan92@gmail.com</a>
				{/* <a href="mailto:name@email.com">Link text</a> */}
			</div>
		</div>
	);
};

export default Footer;
